import { memo } from 'react';
import { Text } from '~/components/chat/assistant-message/message-parts/Text';
import { ToolCallWithDetails } from '~/components/chat/assistant-message/message-parts/ToolCallWithDetails';
import type { ProcessedPart } from '~/components/chat/assistant-message/types';
import { isTextPart, isToolInvocationPart } from '~/lib/ai';

export interface AssistantMessagePartProps {
  part: ProcessedPart;
}

export const AssistantMessagePartWithDetails = memo((props: AssistantMessagePartProps) => {
  const { part } = props;

  if (isTextPart(part)) {
    return <Text key={part.id} part={part} />;
  }

  if (isToolInvocationPart(part)) {
    return <ToolCallWithDetails key={part.toolInvocation.toolCallId} toolInvocation={part.toolInvocation} />;
  }

  return null;
});

AssistantMessagePartWithDetails.displayName = 'AssistantMessagePartWithDetails';
